
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.a1679084727 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"−","E":"E","‰":"‰"},]);
Globalize.b1296697993 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"−","E":"E","‰":"‰"},]);
Globalize.a1716721341 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"−","E":"E","‰":"‰"},]);
Globalize.b1543109564 = numberParserFn([{",":"."," ":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b46488661 = pluralGeneratorFn(function(n
) {
  return (n == 1) ? 'one' : 'other';
});
Globalize.b660349528 = messageFormatterFn((function(  ) {
  return function(d) { return "Reiser: ferier, billige flyreiser, flybilletter og flypriser"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1248429776 = messageFormatterFn((function(  ) {
  return function(d) { return "Poeng brukt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a325779955 = messageFormatterFn((function(  ) {
  return function(d) { return "Poeng fjernet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1641229897 = messageFormatterFn((function(  ) {
  return function(d) { return "Lukk vinduet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1895091718 = messageFormatterFn((function(  ) {
  return function(d) { return "Skal til"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1271534336 = messageFormatterFn((function(  ) {
  return function(d) { return "Innsjekking"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1647551791 = messageFormatterFn((function(  ) {
  return function(d) { return "Utsjekking"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a893441214 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg dato"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2001016136 = messageFormatterFn((function(  ) {
  return function(d) { return "Gjester"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1373101490 = messageFormatterFn((function(  ) {
  return function(d) { return "Søk"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1428342312 = messageFormatterFn((function(  ) {
  return function(d) { return "Mer informasjon om " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a166204917 = messageFormatterFn((function(  ) {
  return function(d) { return "Åpner " + d["0"] + " i ny fane, gå tilbake til den opprinnelige fanen for å fortsette"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a419552784 = messageFormatterFn((function(  ) {
  return function(d) { return "Søkeresultater"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a182771583 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg et reisemål"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a682645191 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg en gyldig innsjekkingsdato"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b644263208 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg datoer for reisen din"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b177924098 = messageFormatterFn((function(  ) {
  return function(d) { return "Utsjekkingsdatoen må være etter innsjekkingsdatoen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1233952250 = messageFormatterFn((function(  ) {
  return function(d) { return "Utsjekkingsdatoen må være innen 28 dager etter innsjekkingsdatoen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a356096406 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg en gyldig utsjekkingsdato"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a867276932 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg antall reisende"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1172324019 = messageFormatterFn((function(  ) {
  return function(d) { return "Angi barnets alder"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1917091171 = messageFormatterFn((function(  ) {
  return function(d) { return "Angi barnas alder"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1912591803 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppholdsdatoene må være innenfor reisedatoene"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b981687264 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1415773938 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " rom";}, one: function() { return number(d["0"]) + " rom";}, two: function() { return number(d["0"]) + " rom";}, few: function() { return number(d["0"]) + " rom";}, many: function() { return number(d["0"]) + " rom";}, other: function() { return number(d["0"]) + " rom";} }) + ", " + plural(d["1"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["1"]) + " gjester";}, one: function() { return number(d["1"]) + " gjest";}, two: function() { return number(d["1"]) + " gjester";}, few: function() { return number(d["1"]) + " gjester";}, many: function() { return number(d["1"]) + " gjester";}, other: function() { return number(d["1"]) + " gjester";} }); }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.b741509186 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["1"]) + " gjester";}, one: function() { return number(d["1"]) + " gjest";}, two: function() { return number(d["1"]) + " gjester";}, few: function() { return number(d["1"]) + " gjester";}, many: function() { return number(d["1"]) + " gjester";}, other: function() { return number(d["1"]) + " gjester";} }); }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1292079584 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["1"]) + " gjester";}, one: function() { return number(d["1"]) + " gjest";}, two: function() { return number(d["1"]) + " gjester";}, few: function() { return number(d["1"]) + " gjester";}, many: function() { return number(d["1"]) + " gjester";}, other: function() { return number(d["1"]) + " gjester";} }) + ", kjæledyr"; }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.b396308289 = messageFormatterFn((function(  ) {
  return function(d) { return "Reisende"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1311130003 = messageFormatterFn((function(  ) {
  return function(d) { return "Rom " + d["0"] + " lagt til. Rediger opplysninger om gjester ovenfor."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1792693069 = messageFormatterFn((function(  ) {
  return function(d) { return "Rom fjernet. Rediger opplysninger om gjester for rom " + d["0"] + " nedenfor."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b987750935 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt, lukk vinduet hvor du velger antall rom og reisende uten å lagre endringene. Eller rediger opplysningene om gjester nedenfor."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b274049943 = messageFormatterFn((function(  ) {
  return function(d) { return "Ferdig"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a138229233 = messageFormatterFn((function(  ) {
  return function(d) { return "Lagre endringer og lukk siden hvor du velger antall reisende."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b523702565 = messageFormatterFn((function(  ) {
  return function(d) { return "Legg til et rom"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1307558234 = messageFormatterFn((function(  ) {
  return function(d) { return "Fjern rom"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b184960594 = messageFormatterFn((function(  ) {
  return function(d) { return "Fjern rom " + d["0"] + " av " + d["1"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a224671156 = messageFormatterFn((function(  ) {
  return function(d) { return "Alder på barn " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2117424556 = messageFormatterFn((function(  ) {
  return function(d) { return "Rom " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1814802867 = messageFormatterFn((function(  ) {
  return function(d) { return "Rom " + d["0"] + " av " + d["1"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1380640661 = messageFormatterFn((function(  ) {
  return function(d) { return "Barn " + d["0"] + ", alder endret til " + d["1"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2102553105 = messageFormatterFn((function(  ) {
  return function(d) { return "Under 1"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b56999645 = messageFormatterFn((function(  ) {
  return function(d) { return "Barn"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2022543290 = messageFormatterFn((function(  ) {
  return function(d) { return "(0 til 17 år)"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2068938553 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " voksne";}, one: function() { return number(d["0"]) + " voksen";}, two: function() { return number(d["0"]) + " voksne";}, few: function() { return number(d["0"]) + " voksne";}, many: function() { return number(d["0"]) + " voksne";}, other: function() { return number(d["0"]) + " voksne";} }); }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1391134349 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " barn";}, one: function() { return number(d["0"]) + " barn";}, two: function() { return number(d["0"]) + " barn";}, few: function() { return number(d["0"]) + " barn";}, many: function() { return number(d["0"]) + " barn";}, other: function() { return number(d["0"]) + " barn";} }); }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.a112494313 = messageFormatterFn((function(  ) {
  return function(d) { return "Voksne"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1024832677 = messageFormatterFn((function(  ) {
  return function(d) { return "Reduser antall barn på rom " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b954535189 = messageFormatterFn((function(  ) {
  return function(d) { return "Reduser antall voksne på rom " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1791050369 = messageFormatterFn((function(  ) {
  return function(d) { return "Øk antall barn på rom " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a717768647 = messageFormatterFn((function(  ) {
  return function(d) { return "Øk antall voksne på rom " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b528338003 = messageFormatterFn((function(  ) {
  return function(d) { return "Kjæledyr"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a715708745 = messageFormatterFn((function(  ) {
  return function(d) { return "Kjæledyr inkludert?"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b286342275 = messageFormatterFn((function(  ) {
  return function(d) { return "Ja"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1398224849 = messageFormatterFn((function(  ) {
  return function(d) { return "Nei"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a813205689 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har blitt lagt til i listene dine"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1570042323 = messageFormatterFn((function(  ) {
  return function(d) { return "Åpnes i et nytt vindu"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b583823912 = messageFormatterFn((function(  ) {
  return function(d) { return "Gjesteanmeldelser"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1262610960 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt, gå tilbake til hotellopplysningene."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1861858200 = messageFormatterFn((function(  ) {
  return function(d) { return "Sjekk tilgjengelighet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1160273901 = messageFormatterFn((function(  ) {
  return function(d) { return "Søk"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b961265759 = messageFormatterFn((function(  ) {
  return function(d) { return "Endre søket"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1294698652 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg en senere innsjekkingsdato"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1945835272 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg en tidligere innsjekkingsdato"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1936203459 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg en senere utsjekkingsdato"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1304330465 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg en tidligere utsjekkingsdato"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2104412281 = messageFormatterFn((function(  ) {
  return function(d) { return "Prisen var " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a616639239 = messageFormatterFn((function(  ) {
  return function(d) { return "Prisen er " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1395730516 = messageFormatterFn((function(  ) {
  return function(d) { return "Prisen er nå " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b351861254 = messageFormatterFn((function(  ) {
  return function(d) { return "Prisen var " + d["0"] + ", prisen er nå " + d["1"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a879035309 = messageFormatterFn((function(  ) {
  return function(d) { return "per natt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b132612189 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt, gå tilbake til hotellopplysningene."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a473016955 = messageFormatterFn((function(  ) {
  return function(d) { return "Mer informasjon"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b786339195 = messageFormatterFn((function(  ) {
  return function(d) { return "Lukk, gå tilbake til hotellopplysningene."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1915471313 = messageFormatterFn((function(  ) {
  return function(d) { return "Noe har gått galt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1794059799 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv et nytt søk."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a393479025 = messageFormatterFn((function(  ) {
  return function(d) { return "Se alternativer og bestill"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a511104359 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsett"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1242797724 = messageFormatterFn((function(  ) {
  return function(d) { return "Du vil kanskje også like"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1380675493 = messageFormatterFn((function(  ) {
  return function(d) { return "Det du ser, er det du betaler"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b574561350 = messageFormatterFn((function(  ) {
  return function(d) { return "Totalprisen inkluderer alle skatter og avgifter."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1687557071 = messageFormatterFn((function(  ) {
  return function(d) { return "Lukk filtre"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b510093609 = messageFormatterFn((function(  ) {
  return function(d) { return "Sortering og filtre"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a263241319 = messageFormatterFn((function(  ) {
  return function(d) { return "Ferdig"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b237620380 = messageFormatterFn((function(  ) {
  return function(d) { return "Tøm"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b534050565 = messageFormatterFn((function(  ) {
  return function(d) { return "Klikk bruk eller gå tilbake for å lukke filtrene"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a235490685 = messageFormatterFn((function(  ) {
  return function(d) { return "Minstepris"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b643666929 = messageFormatterFn((function(  ) {
  return function(d) { return "Makspris"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1138750860 = messageFormatterFn((function(  ) {
  return function(d) { return "Stjernerangering"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b133784933 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorter etter"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2037546724 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtrer etter"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1162772060 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilbake til hotellsøk"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1702783578 = messageFormatterFn((function(  ) {
  return function(d) { return "Søker blant tusenvis av overnattingssteder"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a919864907 = messageFormatterFn((function(  ) {
  return function(d) { return "Søker blant tusenvis av pakkereiser"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b793052237 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi sammenligner priser fra populære leiebilselskaper for å gi deg de beste tilbudene"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a807778092 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi hjelper deg med å finne de beste tilbudene på leiebil"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1079354743 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " filtre";}, one: function() { return number(d["0"]) + " filter";}, two: function() { return number(d["0"]) + " filtre";}, few: function() { return number(d["0"]) + " filtre";}, many: function() { return number(d["0"]) + " filtre";}, other: function() { return number(d["0"]) + " filtre";} }) + " er tatt i bruk"; }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1911789769 = messageFormatterFn((function(  ) {
  return function(d) { return "Sortering og filtre"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b376207773 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtre"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a524941034 = messageFormatterFn((function(  ) {
  return function(d) { return "Kart"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a684890412 = messageFormatterFn((function(  ) {
  return function(d) { return "Gå til kartet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1863106553 = messageFormatterFn((function(  ) {
  return function(d) { return "resultatene lastes"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1648594264 = messageFormatterFn((function(  ) {
  return function(d) { return "resultatene er oppdatert"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1297375496 = messageFormatterFn((function(  ) {
  return function(d) { return "en feil oppsto under henting av resultatene"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a498294756 = messageFormatterFn((function(  ) {
  return function(d) { return "resultatene er tomme"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b773506334 = messageFormatterFn((function(  ) {
  return function(d) { return "Søk etter hoteller"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1008335471 = messageFormatterFn((function(  ) {
  return function(d) { return "Lukk"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b126583740 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv disse datoene i stedet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a167550850 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis flere datoer"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a129729734 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis færre datoer"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1693284629 = messageFormatterFn((function(  ) {
  return function(d) { return "Privat vert"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a778822885 = messageFormatterFn((function(  ) {
  return function(d) { return "Profesjonell vert"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1926532727 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " – hotellsøkeresultater"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b766852115 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ": søkeresultater for ferieboliger"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2075321692 = messageFormatterFn((function(  ) {
  return function(d) { return "Ugyldige hotellsøkeresultater"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1386569662 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis mer"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1172304484 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, vi fant ingen resultater. Prøv å endre søket ditt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b90110022 = messageFormatterFn((function(  ) {
  return function(d) { return "Valgt filter"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2038037668 = messageFormatterFn((function(  ) {
  return function(d) { return "Valgte filtre"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1369531932 = messageFormatterFn((function(  ) {
  return function(d) { return "Reisemål mangler"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1940598248 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "−" + d["1"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a58406344 = messageFormatterFn((function(  ) {
  return function(d) { return "Fjern alle filtre"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a690604359 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " gjester";}, one: function() { return number(d["0"]) + " gjest";}, two: function() { return number(d["0"]) + " gjester";}, few: function() { return number(d["0"]) + " gjester";}, many: function() { return number(d["0"]) + " gjester";}, other: function() { return number(d["0"]) + " gjester";} }); }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1693232033 = messageFormatterFn((function(  ) {
  return function(d) { return "Det har dessverre oppstått et problem"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1177028020 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv igjen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b431305020 = messageFormatterFn((function(  ) {
  return function(d) { return "Lagre " + d["0"] + " i listene dine"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1427977798 = messageFormatterFn((function(  ) {
  return function(d) { return "Fjern " + d["0"] + " fra listene dine"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1390798146 = messageFormatterFn((function(  ) {
  return function(d) { return "Opplysninger om ditt neste opphold"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b799687495 = messageFormatterFn((function(  ) {
  return function(d) { return "Søk i dette området"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1900949081 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, det oppsto en feil. Prøv å søke på nytt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b504721614 = messageFormatterFn((function(  ) {
  return function(d) { return "Lukk kartet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a857980706 = messageFormatterFn((function(  ) {
  return function(d) { return "Utvid kart"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a263893389 = messageFormatterFn((function(  ) {
  return function(d) { return "Utvid kartet med søkeresultatene"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1806676719 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis liste"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1212589402 = messageFormatterFn((function(  ) {
  return function(d) { return "Minimer kartet med søkeresultatene for å vise listen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a74028590 = messageFormatterFn((function(  ) {
  return function(d) { return "Innholdet for overnattingsstedet lastes inn"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b156215830 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " overnattingssteder";}, one: function() { return number(d["0"]) + " overnattingssted";}, two: function() { return number(d["0"]) + " overnattingssteder";}, few: function() { return number(d["0"]) + " overnattingssteder";}, many: function() { return number(d["0"]) + " overnattingssteder";}, other: function() { return number(d["0"]) + " overnattingssteder";} }) + "\nfra " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1572759667 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " overnattingssteder";}, one: function() { return number(d["0"]) + " overnattingssted";}, two: function() { return number(d["0"]) + " overnattingssteder";}, few: function() { return number(d["0"]) + " overnattingssteder";}, many: function() { return number(d["0"]) + " overnattingssteder";}, other: function() { return number(d["0"]) + " overnattingssteder";} }); }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1279788998 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis mer"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a711634573 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis mindre"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b283817051 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, det oppsto en feil hos oss"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b394842895 = messageFormatterFn((function(  ) {
  return function(d) { return "Neste element"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1771250165 = messageFormatterFn((function(  ) {
  return function(d) { return "Forrige element"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b992386152 = messageFormatterFn((function(  ) {
  return function(d) { return "Betaling"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b749062343 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Din reise (" + plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " rom";}, one: function() { return number(d["0"]) + " rom";}, two: function() { return number(d["0"]) + " rom";}, few: function() { return number(d["0"]) + " rom";}, many: function() { return number(d["0"]) + " rom";}, other: function() { return number(d["0"]) + " rom";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.b562463106 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Din reise (" + plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " overnattingssteder";}, one: function() { return number(d["0"]) + " overnattingssted";}, two: function() { return number(d["0"]) + " overnattingssteder";}, few: function() { return number(d["0"]) + " overnattingssteder";}, many: function() { return number(d["0"]) + " overnattingssteder";}, other: function() { return number(d["0"]) + " overnattingssteder";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1426313598 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg det neste rommet ditt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b244620197 = messageFormatterFn((function(  ) {
  return function(d) { return "Ikke lenger tilgjengelig"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a288286009 = messageFormatterFn((function(  ) {
  return function(d) { return "Ett eller flere av overnattingsstedene for reisen din er ikke lenger tilgjengelig. Vil du fortsette til betalingssiden likevel?"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1751136128 = messageFormatterFn((function(  ) {
  return function(d) { return "per rom"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a453174936 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " gjester";}, one: function() { return number(d["0"]) + " gjest";}, two: function() { return number(d["0"]) + " gjester";}, few: function() { return number(d["0"]) + " gjester";}, many: function() { return number(d["0"]) + " gjester";}, other: function() { return number(d["0"]) + " gjester";} }); }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1221866452 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " rom";}, one: function() { return number(d["0"]) + " rom";}, two: function() { return number(d["0"]) + " rom";}, few: function() { return number(d["0"]) + " rom";}, many: function() { return number(d["0"]) + " rom";}, other: function() { return number(d["0"]) + " rom";} }) + ", " + plural(d["1"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["1"]) + " gjester";}, one: function() { return number(d["1"]) + " gjest";}, two: function() { return number(d["1"]) + " gjester";}, few: function() { return number(d["1"]) + " gjester";}, many: function() { return number(d["1"]) + " gjester";}, other: function() { return number(d["1"]) + " gjester";} }); }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1579579655 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " per natt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1712453343 = messageFormatterFn((function(  ) {
  return function(d) { return "Endre rom"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b572045771 = messageFormatterFn((function(  ) {
  return function(d) { return "Kode kopiert til utklippstavlen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b122792626 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, det har oppstått et problem"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b187277871 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv å søke på nytt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b3263429 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv på nytt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2068454840 = messageFormatterFn((function(  ) {
  return function(d) { return "Henting og levering av leiebil"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a927289119 = messageFormatterFn((function(  ) {
  return function(d) { return "Hentetid"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1805192659 = messageFormatterFn((function(  ) {
  return function(d) { return "Leveringstid"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a475063372 = messageFormatterFn((function(  ) {
  return function(d) { return "Leiebil"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b865168839 = messageFormatterFn((function(  ) {
  return function(d) { return "Leveringstidspunktet må være minst to timer etter hentetidspunktet."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2021980005 = messageFormatterFn((function(  ) {
  return function(d) { return "00.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2022069378 = messageFormatterFn((function(  ) {
  return function(d) { return "00.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2022903526 = messageFormatterFn((function(  ) {
  return function(d) { return "01.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2022992899 = messageFormatterFn((function(  ) {
  return function(d) { return "01.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2023827047 = messageFormatterFn((function(  ) {
  return function(d) { return "02.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2023916420 = messageFormatterFn((function(  ) {
  return function(d) { return "02.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2024750568 = messageFormatterFn((function(  ) {
  return function(d) { return "03.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2024839941 = messageFormatterFn((function(  ) {
  return function(d) { return "03.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2025674089 = messageFormatterFn((function(  ) {
  return function(d) { return "04.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2025763462 = messageFormatterFn((function(  ) {
  return function(d) { return "04.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2026597610 = messageFormatterFn((function(  ) {
  return function(d) { return "05.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2026686983 = messageFormatterFn((function(  ) {
  return function(d) { return "05.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2027521131 = messageFormatterFn((function(  ) {
  return function(d) { return "06.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2027610504 = messageFormatterFn((function(  ) {
  return function(d) { return "06.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2028444652 = messageFormatterFn((function(  ) {
  return function(d) { return "07.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2028534025 = messageFormatterFn((function(  ) {
  return function(d) { return "07.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2029368173 = messageFormatterFn((function(  ) {
  return function(d) { return "08.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2029457546 = messageFormatterFn((function(  ) {
  return function(d) { return "08.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2030291694 = messageFormatterFn((function(  ) {
  return function(d) { return "09.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2030381067 = messageFormatterFn((function(  ) {
  return function(d) { return "09.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2050609156 = messageFormatterFn((function(  ) {
  return function(d) { return "10.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2050698529 = messageFormatterFn((function(  ) {
  return function(d) { return "10.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2051532677 = messageFormatterFn((function(  ) {
  return function(d) { return "11.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2051622050 = messageFormatterFn((function(  ) {
  return function(d) { return "11.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2052456198 = messageFormatterFn((function(  ) {
  return function(d) { return "12.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2052545571 = messageFormatterFn((function(  ) {
  return function(d) { return "12.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2053379719 = messageFormatterFn((function(  ) {
  return function(d) { return "13.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2053469092 = messageFormatterFn((function(  ) {
  return function(d) { return "13.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2054303240 = messageFormatterFn((function(  ) {
  return function(d) { return "14.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2054392613 = messageFormatterFn((function(  ) {
  return function(d) { return "14.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2055226761 = messageFormatterFn((function(  ) {
  return function(d) { return "15.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2055316134 = messageFormatterFn((function(  ) {
  return function(d) { return "15.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2056150282 = messageFormatterFn((function(  ) {
  return function(d) { return "16.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2056239655 = messageFormatterFn((function(  ) {
  return function(d) { return "16.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2057073803 = messageFormatterFn((function(  ) {
  return function(d) { return "17.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2057163176 = messageFormatterFn((function(  ) {
  return function(d) { return "17.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2057997324 = messageFormatterFn((function(  ) {
  return function(d) { return "18.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2058086697 = messageFormatterFn((function(  ) {
  return function(d) { return "18.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2058920845 = messageFormatterFn((function(  ) {
  return function(d) { return "19.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2059010218 = messageFormatterFn((function(  ) {
  return function(d) { return "19.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2079238307 = messageFormatterFn((function(  ) {
  return function(d) { return "20.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2079327680 = messageFormatterFn((function(  ) {
  return function(d) { return "20.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2080161828 = messageFormatterFn((function(  ) {
  return function(d) { return "21.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2080251201 = messageFormatterFn((function(  ) {
  return function(d) { return "21.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2081085349 = messageFormatterFn((function(  ) {
  return function(d) { return "22.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2081174722 = messageFormatterFn((function(  ) {
  return function(d) { return "22.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2082008870 = messageFormatterFn((function(  ) {
  return function(d) { return "23.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2082098243 = messageFormatterFn((function(  ) {
  return function(d) { return "23.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a563343846 = messageFormatterFn((function(  ) {
  return function(d) { return "Kun direkteruter"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1823227751 = messageFormatterFn((function(  ) {
  return function(d) { return "Foretrukket kabinklasse"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a711533089 = messageFormatterFn((function(  ) {
  return function(d) { return "Economy"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b419407418 = messageFormatterFn((function(  ) {
  return function(d) { return "Premium Economy"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1471643423 = messageFormatterFn((function(  ) {
  return function(d) { return "Business"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1619831943 = messageFormatterFn((function(  ) {
  return function(d) { return "First Class"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1534470306 = messageFormatterFn((function(  ) {
  return function(d) { return "Gjester"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b246563228 = messageFormatterFn((function(  ) {
  return function(d) { return "Det må være minst 1 reisende (over 6 år) for hvert spedbarn på fanget."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b368544609 = messageFormatterFn((function(  ) {
  return function(d) { return "Spedbarn"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1605746520 = messageFormatterFn((function(  ) {
  return function(d) { return "(2–17 år)"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1834239158 = messageFormatterFn((function(  ) {
  return function(d) { return "(under 2 år)"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1476182520 = messageFormatterFn((function(  ) {
  return function(d) { return "Alder på spedbarn " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1866926764 = messageFormatterFn((function(  ) {
  return function(d) { return "Reduser antall spedbarn på rom " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a304814128 = messageFormatterFn((function(  ) {
  return function(d) { return "Øk antall spedbarn på rom " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1111969090 = messageFormatterFn((function(  ) {
  return function(d) { return "Barn under 2 år må sitte i et barnesete eller på fanget"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1598930070 = messageFormatterFn((function(  ) {
  return function(d) { return "På fanget"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1424466680 = messageFormatterFn((function(  ) {
  return function(d) { return "I sete"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b795258777 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyselskapets aldersregler"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1476400467 = messageFormatterFn((function(  ) {
  return function(d) { return "Reiser fra"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1510436939 = messageFormatterFn((function(  ) {
  return function(d) { return "Avreise"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1471534607 = messageFormatterFn((function(  ) {
  return function(d) { return "Retur"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b768941233 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg et avreisested"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1758136201 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg trenger bare overnatting for deler av reisen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1502176886 = messageFormatterFn((function(  ) {
  return function(d) { return "Det oppsto en feil. Prøv igjen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b205362978 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg minst 1 overnattingssted til for å sammenligne"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b109936795 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "/" + plural(d["1"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["1"]) + " overnattingssteder";}, one: function() { return number(d["1"]) + " overnattingssted";}, two: function() { return number(d["1"]) + " overnattingssteder";}, few: function() { return number(d["1"]) + " overnattingssteder";}, many: function() { return number(d["1"]) + " overnattingssteder";}, other: function() { return number(d["1"]) + " overnattingssteder";} }) + " er valgt"; }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.a101126615 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " av " + plural(d["1"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["1"]) + " overnattingssteder";}, one: function() { return number(d["1"]) + " overnattingssted";}, two: function() { return number(d["1"]) + " overnattingssteder";}, few: function() { return number(d["1"]) + " overnattingssteder";}, many: function() { return number(d["1"]) + " overnattingssteder";}, other: function() { return number(d["1"]) + " overnattingssteder";} }) + " er valgt for sammenligning"; }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1682064283 = messageFormatterFn((function(  ) {
  return function(d) { return "Sammenlign"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a842659031 = messageFormatterFn((function(  ) {
  return function(d) { return "Sammenlign valgte overnattingssteder"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1499100879 = messageFormatterFn((function(  ) {
  return function(d) { return "Sammenlign"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1483622283 = messageFormatterFn((function(  ) {
  return function(d) { return "Sammenlign valgte overnattingssteder"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1632446525 = messageFormatterFn((function(  ) {
  return function(d) { return "Se"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1792266241 = messageFormatterFn((function(  ) {
  return function(d) { return "Klikk for å se overnattingsstedet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b589117668 = messageFormatterFn((function(  ) {
  return function(d) { return "Fjern"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a686949504 = messageFormatterFn((function(  ) {
  return function(d) { return "Klikk for å fjerne overnattingsstedet fra sammenligningen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b581283082 = messageFormatterFn((function(  ) {
  return function(d) { return "Lukk sammenligning av overnattingssteder"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1445479504 = messageFormatterFn((function(  ) {
  return function(d) { return "Sammenlign overnattingssteder"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a935819321 = messageFormatterFn((function(  ) {
  return function(d) { return "Se opptil 5 overnattingssteder side om side for å gjøre det enklere å velge. Klikk på «Sammenlign» for å begynne."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1054546837 = messageFormatterFn((function(  ) {
  return function(d) { return "Se opptil 5 overnattingssteder side om side for å gjøre det enklere å velge."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b230297699 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv nå"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1450531207 = messageFormatterFn((function(  ) {
  return function(d) { return "Begynn å sammenligne"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b553727259 = messageFormatterFn((function(  ) {
  return function(d) { return "Deaktiver sammenligning"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a14149439 = messageFormatterFn((function(  ) {
  return function(d) { return "Kanskje senere"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a966310588 = messageFormatterFn((function(  ) {
  return function(d) { return "Sammenlign overnattingssteder"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1690848159 = messageFormatterFn((function(  ) {
  return function(d) { return "Klikk på «Sammenlign» i søkeresultatene for å begynne."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a876510661 = messageFormatterFn((function(  ) {
  return function(d) { return "Se opptil 5 overnattingssteder side om side."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b344838162 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingen tilgjengelighet den " + d["0"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1422028469 = messageFormatterFn((function(  ) {
  return function(d) { return "Utsjekking er ikke mulig den " + d["0"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1866383610 = messageFormatterFn((function(  ) {
  return function(d) { return "Innsjekking er ikke mulig den " + d["0"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a842857556 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2048916744 = messageFormatterFn((function(  ) {
  return function(d) { return "Se alle fasilitetene på overnattingsstedet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b420550293 = messageFormatterFn((function(  ) {
  return function(d) { return "Gjesteanmeldelser"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b306492848 = messageFormatterFn((function(  ) {
  return function(d) { return "Høydepunkter i området"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2143100231 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilpass oppholdet ditt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a30684761 = messageFormatterFn((function(  ) {
  return function(d) { return "Lukk delen Tilpass oppholdet ditt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1954905808 = messageFormatterFn((function(  ) {
  return function(d) { return "Send en melding til verten"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1340989753 = messageFormatterFn((function(  ) {
  return function(d) { return "Det oppsto en feil"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a496279478 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv igjen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b455148648 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv igjen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1107999323 = messageFormatterFn((function(  ) {
  return function(d) { return "Annonse"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1849562029 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv igjen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1290011716 = messageFormatterFn((function(  ) {
  return function(d) { return "Om denne annonsen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1638883898 = messageFormatterFn((function(  ) {
  return function(d) { return "Det oppsto et problem da vi skulle hente denne informasjonen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1965664472 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kan ikke vise denne informasjonen akkurat nå."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1546107472 = messageFormatterFn((function(  ) {
  return function(d) { return "Rutenett"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1101179603 = messageFormatterFn((function(  ) {
  return function(d) { return "Tabellvisning"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1410960120 = messageFormatterFn((function(  ) {
  return function(d) { return "Liste"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1236326955 = messageFormatterFn((function(  ) {
  return function(d) { return "Listevisning"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2074157991 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", valgt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1109398734 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", ikke valgt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b95829720 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle skatter og avgifter er inkludert i totalprisen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1181709559 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingen overraskelser"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1389449061 = messageFormatterFn((function(  ) {
  return function(d) { return "Vrbo-priser inkluderer alle gebyrer"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1701441846 = messageFormatterFn((function(  ) {
  return function(d) { return "Prisen du ser, er den du betaler"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1667757033 = messageFormatterFn((function(  ) {
  return function(d) { return "Det du ser, er det du betaler."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b485300360 = messageFormatterFn((function(  ) {
  return function(d) { return "Ikke alle reisesider viser deg totalprisen på forhånd. Det gjør vi. Det du ser, er det du betaler."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b810057258 = messageFormatterFn((function(  ) {
  return function(d) { return "Skatter legges til ved betaling"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1834510180 = messageFormatterFn((function(  ) {
  return function(d) { return "Sammenligner du priser?"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1927025829 = messageFormatterFn((function(  ) {
  return function(d) { return "Totalprisen inkluderer skatter og avgifter på forhånd."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1610185080 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsett søket"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1569001008 = messageFormatterFn((function(  ) {
  return function(d) { return "Garanti for trygg og sikker bestilling"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1691987062 = messageFormatterFn((function(  ) {
  return function(d) { return "Det er ikke alltid alt går etter planen. Derfor er vi her for å hjelpe deg hvis det oppstår problemer med oppholdet ditt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b439160213 = messageFormatterFn((function(  ) {
  return function(d) { return "Kundeservice 24 timer i døgnet hvis du trenger hjelp før, under eller etter oppholdet."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b180026849 = messageFormatterFn((function(  ) {
  return function(d) { return "Betalingsbeskyttelse og forebygging av svindel knyttet til depositum og gebyrer."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1895120898 = messageFormatterFn((function(  ) {
  return function(d) { return "Dedikert hjelp til å finne et nytt overnattingssted hvis bestillingen kanselleres."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b841365467 = messageFormatterFn((function(  ) {
  return function(d) { return "Hjelp i nødstilfeller hvis du ikke får tilgang til overnattingsstedet ved ankomst."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1826986357 = messageFormatterFn((function(  ) {
  return function(d) { return "Åpningstider"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a859093033 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ": søkeresultater for leiebil"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2080538891 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har forlenget oppholdet ditt med " + plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " netter";}, one: function() { return number(d["0"]) + " natt";}, two: function() { return number(d["0"]) + " netter";}, few: function() { return number(d["0"]) + " netter";}, many: function() { return number(d["0"]) + " netter";}, other: function() { return number(d["0"]) + " netter";} }) + "."; }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1767143398 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Legg til " + plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " netter";}, one: function() { return number(d["0"]) + " natt";}, two: function() { return number(d["0"]) + " netter";}, few: function() { return number(d["0"]) + " netter";}, many: function() { return number(d["0"]) + " netter";}, other: function() { return number(d["0"]) + " netter";} }) + " og spar penger"; }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1888514314 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne verten tilbyr månedsrabatt for opphold på 28 eller flere netter."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1282227386 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne verten tilbyr ukesrabatt for opphold på 7 eller flere netter."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b206930392 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Legg til " + plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " netter";}, one: function() { return number(d["0"]) + " natt";}, two: function() { return number(d["0"]) + " netter";}, few: function() { return number(d["0"]) + " netter";}, many: function() { return number(d["0"]) + " netter";}, other: function() { return number(d["0"]) + " netter";} }); }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.a522577615 = messageFormatterFn((function(  ) {
  return function(d) { return "00.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2038026027 = messageFormatterFn((function(  ) {
  return function(d) { return "00.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b573309166 = messageFormatterFn((function(  ) {
  return function(d) { return "00.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a942139246 = messageFormatterFn((function(  ) {
  return function(d) { return "00.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1111609267 = messageFormatterFn((function(  ) {
  return function(d) { return "01.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1667909617 = messageFormatterFn((function(  ) {
  return function(d) { return "01.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a15722486 = messageFormatterFn((function(  ) {
  return function(d) { return "01.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1531170898 = messageFormatterFn((function(  ) {
  return function(d) { return "01.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1240691986 = messageFormatterFn((function(  ) {
  return function(d) { return "02.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1538826898 = messageFormatterFn((function(  ) {
  return function(d) { return "02.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a144805205 = messageFormatterFn((function(  ) {
  return function(d) { return "02.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1660253617 = messageFormatterFn((function(  ) {
  return function(d) { return "02.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1369774705 = messageFormatterFn((function(  ) {
  return function(d) { return "03.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1409744179 = messageFormatterFn((function(  ) {
  return function(d) { return "03.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a273887924 = messageFormatterFn((function(  ) {
  return function(d) { return "03.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1789336336 = messageFormatterFn((function(  ) {
  return function(d) { return "03.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1498857424 = messageFormatterFn((function(  ) {
  return function(d) { return "04.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1280661460 = messageFormatterFn((function(  ) {
  return function(d) { return "04.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a402970643 = messageFormatterFn((function(  ) {
  return function(d) { return "04.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1918419055 = messageFormatterFn((function(  ) {
  return function(d) { return "04.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1627940143 = messageFormatterFn((function(  ) {
  return function(d) { return "05.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1151578741 = messageFormatterFn((function(  ) {
  return function(d) { return "05.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a532053362 = messageFormatterFn((function(  ) {
  return function(d) { return "05.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2047501774 = messageFormatterFn((function(  ) {
  return function(d) { return "05.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1757022862 = messageFormatterFn((function(  ) {
  return function(d) { return "06.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1022496022 = messageFormatterFn((function(  ) {
  return function(d) { return "06.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a661136081 = messageFormatterFn((function(  ) {
  return function(d) { return "06.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2118382803 = messageFormatterFn((function(  ) {
  return function(d) { return "06.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1886105581 = messageFormatterFn((function(  ) {
  return function(d) { return "07.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b893413303 = messageFormatterFn((function(  ) {
  return function(d) { return "07.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a790218800 = messageFormatterFn((function(  ) {
  return function(d) { return "07.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1989300084 = messageFormatterFn((function(  ) {
  return function(d) { return "07.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2015188300 = messageFormatterFn((function(  ) {
  return function(d) { return "08.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b764330584 = messageFormatterFn((function(  ) {
  return function(d) { return "08.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a919301519 = messageFormatterFn((function(  ) {
  return function(d) { return "08.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1860217365 = messageFormatterFn((function(  ) {
  return function(d) { return "08.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2144271019 = messageFormatterFn((function(  ) {
  return function(d) { return "09.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b635247865 = messageFormatterFn((function(  ) {
  return function(d) { return "09.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1048384238 = messageFormatterFn((function(  ) {
  return function(d) { return "09.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1731134646 = messageFormatterFn((function(  ) {
  return function(d) { return "09.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a264412177 = messageFormatterFn((function(  ) {
  return function(d) { return "10.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1779860589 = messageFormatterFn((function(  ) {
  return function(d) { return "10.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b831474604 = messageFormatterFn((function(  ) {
  return function(d) { return "10.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a683973808 = messageFormatterFn((function(  ) {
  return function(d) { return "10.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a393494896 = messageFormatterFn((function(  ) {
  return function(d) { return "11.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1908943308 = messageFormatterFn((function(  ) {
  return function(d) { return "11.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b702391885 = messageFormatterFn((function(  ) {
  return function(d) { return "11.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a813056527 = messageFormatterFn((function(  ) {
  return function(d) { return "11.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b819435554 = messageFormatterFn((function(  ) {
  return function(d) { return "12.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a696012858 = messageFormatterFn((function(  ) {
  return function(d) { return "12.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1915322335 = messageFormatterFn((function(  ) {
  return function(d) { return "12.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b399873923 = messageFormatterFn((function(  ) {
  return function(d) { return "12.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b230403902 = messageFormatterFn((function(  ) {
  return function(d) { return "13.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1285044510 = messageFormatterFn((function(  ) {
  return function(d) { return "13.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1326290683 = messageFormatterFn((function(  ) {
  return function(d) { return "13.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a189157729 = messageFormatterFn((function(  ) {
  return function(d) { return "13.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b101321183 = messageFormatterFn((function(  ) {
  return function(d) { return "14.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1414127229 = messageFormatterFn((function(  ) {
  return function(d) { return "14.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1197207964 = messageFormatterFn((function(  ) {
  return function(d) { return "14.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a318240448 = messageFormatterFn((function(  ) {
  return function(d) { return "14.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a27761536 = messageFormatterFn((function(  ) {
  return function(d) { return "15.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1543209948 = messageFormatterFn((function(  ) {
  return function(d) { return "15.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1068125245 = messageFormatterFn((function(  ) {
  return function(d) { return "15.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a447323167 = messageFormatterFn((function(  ) {
  return function(d) { return "15.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a156844255 = messageFormatterFn((function(  ) {
  return function(d) { return "16.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1672292667 = messageFormatterFn((function(  ) {
  return function(d) { return "16.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b939042526 = messageFormatterFn((function(  ) {
  return function(d) { return "16.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a576405886 = messageFormatterFn((function(  ) {
  return function(d) { return "16.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a285926974 = messageFormatterFn((function(  ) {
  return function(d) { return "17.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1801375386 = messageFormatterFn((function(  ) {
  return function(d) { return "17.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b809959807 = messageFormatterFn((function(  ) {
  return function(d) { return "17.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a705488605 = messageFormatterFn((function(  ) {
  return function(d) { return "17.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a415009693 = messageFormatterFn((function(  ) {
  return function(d) { return "18.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1930458105 = messageFormatterFn((function(  ) {
  return function(d) { return "18.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b680877088 = messageFormatterFn((function(  ) {
  return function(d) { return "18.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a834571324 = messageFormatterFn((function(  ) {
  return function(d) { return "18.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a544092412 = messageFormatterFn((function(  ) {
  return function(d) { return "19.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2059540824 = messageFormatterFn((function(  ) {
  return function(d) { return "19.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b551794369 = messageFormatterFn((function(  ) {
  return function(d) { return "19.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a963654043 = messageFormatterFn((function(  ) {
  return function(d) { return "19.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a673175131 = messageFormatterFn((function(  ) {
  return function(d) { return "20.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2106343753 = messageFormatterFn((function(  ) {
  return function(d) { return "20.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b422711650 = messageFormatterFn((function(  ) {
  return function(d) { return "20.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1092736762 = messageFormatterFn((function(  ) {
  return function(d) { return "20.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a802257850 = messageFormatterFn((function(  ) {
  return function(d) { return "21.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1977261034 = messageFormatterFn((function(  ) {
  return function(d) { return "21.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b293628931 = messageFormatterFn((function(  ) {
  return function(d) { return "21.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1221819481 = messageFormatterFn((function(  ) {
  return function(d) { return "21.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1077600992 = messageFormatterFn((function(  ) {
  return function(d) { return "22.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a437847420 = messageFormatterFn((function(  ) {
  return function(d) { return "22.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2121479523 = messageFormatterFn((function(  ) {
  return function(d) { return "22.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b658039361 = messageFormatterFn((function(  ) {
  return function(d) { return "22.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b948518273 = messageFormatterFn((function(  ) {
  return function(d) { return "23.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a566930139 = messageFormatterFn((function(  ) {
  return function(d) { return "23.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2044405054 = messageFormatterFn((function(  ) {
  return function(d) { return "23.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b528956642 = messageFormatterFn((function(  ) {
  return function(d) { return "23.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b535870204 = messageFormatterFn((function(  ) {
  return function(d) { return "00.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1556111520 = messageFormatterFn((function(  ) {
  return function(d) { return "00.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b308182073 = messageFormatterFn((function(  ) {
  return function(d) { return "00.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1328423389 = messageFormatterFn((function(  ) {
  return function(d) { return "00.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b813425688 = messageFormatterFn((function(  ) {
  return function(d) { return "01.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1833667004 = messageFormatterFn((function(  ) {
  return function(d) { return "01.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b585737557 = messageFormatterFn((function(  ) {
  return function(d) { return "01.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1605978873 = messageFormatterFn((function(  ) {
  return function(d) { return "01.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1323959865 = messageFormatterFn((function(  ) {
  return function(d) { return "02.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1950766115 = messageFormatterFn((function(  ) {
  return function(d) { return "02.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1096271734 = messageFormatterFn((function(  ) {
  return function(d) { return "02.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2116513050 = messageFormatterFn((function(  ) {
  return function(d) { return "02.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1834494042 = messageFormatterFn((function(  ) {
  return function(d) { return "03.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1440231938 = messageFormatterFn((function(  ) {
  return function(d) { return "03.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1606805911 = messageFormatterFn((function(  ) {
  return function(d) { return "03.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1667920069 = messageFormatterFn((function(  ) {
  return function(d) { return "03.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1949939077 = messageFormatterFn((function(  ) {
  return function(d) { return "04.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a929697761 = messageFormatterFn((function(  ) {
  return function(d) { return "04.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2117340088 = messageFormatterFn((function(  ) {
  return function(d) { return "04.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1157385892 = messageFormatterFn((function(  ) {
  return function(d) { return "04.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1439404900 = messageFormatterFn((function(  ) {
  return function(d) { return "05.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a419163584 = messageFormatterFn((function(  ) {
  return function(d) { return "05.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1667093031 = messageFormatterFn((function(  ) {
  return function(d) { return "05.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a646851715 = messageFormatterFn((function(  ) {
  return function(d) { return "05.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a928870723 = messageFormatterFn((function(  ) {
  return function(d) { return "06.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b91370593 = messageFormatterFn((function(  ) {
  return function(d) { return "06.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1156558854 = messageFormatterFn((function(  ) {
  return function(d) { return "06.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a136317538 = messageFormatterFn((function(  ) {
  return function(d) { return "06.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a418336546 = messageFormatterFn((function(  ) {
  return function(d) { return "07.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b601904770 = messageFormatterFn((function(  ) {
  return function(d) { return "07.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a646024677 = messageFormatterFn((function(  ) {
  return function(d) { return "07.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b374216639 = messageFormatterFn((function(  ) {
  return function(d) { return "07.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b92197631 = messageFormatterFn((function(  ) {
  return function(d) { return "08.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1112438947 = messageFormatterFn((function(  ) {
  return function(d) { return "08.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a135490500 = messageFormatterFn((function(  ) {
  return function(d) { return "08.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b884750816 = messageFormatterFn((function(  ) {
  return function(d) { return "08.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b602731808 = messageFormatterFn((function(  ) {
  return function(d) { return "09.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1622973124 = messageFormatterFn((function(  ) {
  return function(d) { return "09.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b375043677 = messageFormatterFn((function(  ) {
  return function(d) { return "09.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1395284993 = messageFormatterFn((function(  ) {
  return function(d) { return "09.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a485198150 = messageFormatterFn((function(  ) {
  return function(d) { return "10.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b535043166 = messageFormatterFn((function(  ) {
  return function(d) { return "10.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a712886281 = messageFormatterFn((function(  ) {
  return function(d) { return "10.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b307355035 = messageFormatterFn((function(  ) {
  return function(d) { return "10.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b25336027 = messageFormatterFn((function(  ) {
  return function(d) { return "11.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1045577343 = messageFormatterFn((function(  ) {
  return function(d) { return "11.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a202352104 = messageFormatterFn((function(  ) {
  return function(d) { return "11.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b817889212 = messageFormatterFn((function(  ) {
  return function(d) { return "11.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b641948013 = messageFormatterFn((function(  ) {
  return function(d) { return "12.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1662189329 = messageFormatterFn((function(  ) {
  return function(d) { return "12.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b414259882 = messageFormatterFn((function(  ) {
  return function(d) { return "12.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1434501198 = messageFormatterFn((function(  ) {
  return function(d) { return "12.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b919503497 = messageFormatterFn((function(  ) {
  return function(d) { return "13.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1939744813 = messageFormatterFn((function(  ) {
  return function(d) { return "13.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b691815366 = messageFormatterFn((function(  ) {
  return function(d) { return "13.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1712056682 = messageFormatterFn((function(  ) {
  return function(d) { return "13.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1430037674 = messageFormatterFn((function(  ) {
  return function(d) { return "14.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1844688306 = messageFormatterFn((function(  ) {
  return function(d) { return "14.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1202349543 = messageFormatterFn((function(  ) {
  return function(d) { return "14.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2072376437 = messageFormatterFn((function(  ) {
  return function(d) { return "14.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1940571851 = messageFormatterFn((function(  ) {
  return function(d) { return "15.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1334154129 = messageFormatterFn((function(  ) {
  return function(d) { return "15.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1712883720 = messageFormatterFn((function(  ) {
  return function(d) { return "15.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1561842260 = messageFormatterFn((function(  ) {
  return function(d) { return "15.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1843861268 = messageFormatterFn((function(  ) {
  return function(d) { return "16.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a823619952 = messageFormatterFn((function(  ) {
  return function(d) { return "16.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2071549399 = messageFormatterFn((function(  ) {
  return function(d) { return "16.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1051308083 = messageFormatterFn((function(  ) {
  return function(d) { return "16.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1333327091 = messageFormatterFn((function(  ) {
  return function(d) { return "17.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a313085775 = messageFormatterFn((function(  ) {
  return function(d) { return "17.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1561015222 = messageFormatterFn((function(  ) {
  return function(d) { return "17.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a540773906 = messageFormatterFn((function(  ) {
  return function(d) { return "17.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a822792914 = messageFormatterFn((function(  ) {
  return function(d) { return "18.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b197448402 = messageFormatterFn((function(  ) {
  return function(d) { return "18.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1050481045 = messageFormatterFn((function(  ) {
  return function(d) { return "18.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a30239729 = messageFormatterFn((function(  ) {
  return function(d) { return "18.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a312258737 = messageFormatterFn((function(  ) {
  return function(d) { return "19.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b707982579 = messageFormatterFn((function(  ) {
  return function(d) { return "19.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a539946868 = messageFormatterFn((function(  ) {
  return function(d) { return "19.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b480294448 = messageFormatterFn((function(  ) {
  return function(d) { return "19.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b198275440 = messageFormatterFn((function(  ) {
  return function(d) { return "20.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1218516756 = messageFormatterFn((function(  ) {
  return function(d) { return "20.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a29412691 = messageFormatterFn((function(  ) {
  return function(d) { return "20.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b990828625 = messageFormatterFn((function(  ) {
  return function(d) { return "20.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b708809617 = messageFormatterFn((function(  ) {
  return function(d) { return "21.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1729050933 = messageFormatterFn((function(  ) {
  return function(d) { return "21.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b481121486 = messageFormatterFn((function(  ) {
  return function(d) { return "21.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1501362802 = messageFormatterFn((function(  ) {
  return function(d) { return "21.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a379120341 = messageFormatterFn((function(  ) {
  return function(d) { return "22.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b641120975 = messageFormatterFn((function(  ) {
  return function(d) { return "22.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a606808472 = messageFormatterFn((function(  ) {
  return function(d) { return "22.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b413432844 = messageFormatterFn((function(  ) {
  return function(d) { return "22.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b131413836 = messageFormatterFn((function(  ) {
  return function(d) { return "23.00"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1151655152 = messageFormatterFn((function(  ) {
  return function(d) { return "23.15"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a96274295 = messageFormatterFn((function(  ) {
  return function(d) { return "23.30"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b923967021 = messageFormatterFn((function(  ) {
  return function(d) { return "23.45"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1696499573 = messageFormatterFn((function(  ) {
  return function(d) { return "Lukk"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b164062797 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1108031737 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1715035077 = messageFormatterFn((function(  ) {
  return function(d) { return "Fullfør"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b553711299 = messageFormatterFn((function(  ) {
  return function(d) { return "Fjern"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2001830420 = messageFormatterFn((function(  ) {
  return function(d) { return "valgt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a131141945 = messageFormatterFn((function(  ) {
  return function(d) { return "Laster"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1686740618 = messageFormatterFn((function(  ) {
  return function(d) { return "Tøm"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1337326820 = messageFormatterFn((function(  ) {
  return function(d) { return "Åpnes i et nytt vindu"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b979071778 = messageFormatterFn((function(  ) {
  return function(d) { return "Se mer"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1803748907 = messageFormatterFn((function(  ) {
  return function(d) { return "Se mindre"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1293463143 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis mer"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a321357862 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis mindre"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b141235195 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er valgt. Nå velger du en utsjekkingsdato."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2074164052 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er valgt. Nå velger du “Ferdig” for å lagre disse datoene og lukke kalenderen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1054612176 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", nåværende innsjekkingsdato"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b924734511 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", nåværende utsjekkingsdato"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b310729433 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", dato deaktivert"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b910611996 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", nåværende måned"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1338766721 = messageFormatterFn((function(  ) {
  return function(d) { return "Viser nå " + d["0"] + " og " + d["1"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b282889723 = messageFormatterFn((function(  ) {
  return function(d) { return "Kalender åpnet. Velg en dato fra tabellene nedenfor."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1916710953 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt, lukk kalenderen uten å lagre endringene. Eller velg en dato fra tabellene nedenfor."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a163959367 = messageFormatterFn((function(  ) {
  return function(d) { return "Tøm valgte datoer."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1038774692 = messageFormatterFn((function(  ) {
  return function(d) { return "Lagre endringene og lukk kalenderen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b823774659 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " netter";}, one: function() { return number(d["0"]) + " natt";}, two: function() { return number(d["0"]) + " netter";}, few: function() { return number(d["0"]) + " netter";}, many: function() { return number(d["0"]) + " netter";}, other: function() { return number(d["0"]) + " netter";} }); }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.a903897293 = messageFormatterFn((function(  ) {
  return function(d) { return "Innsjekking"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b442201314 = messageFormatterFn((function(  ) {
  return function(d) { return "Utsjekking"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1045198367 = messageFormatterFn((function(  ) {
  return function(d) { return "Tøm datoer"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1865712446 = messageFormatterFn((function(  ) {
  return function(d) { return "Ferdig"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a328473188 = messageFormatterFn((function(  ) {
  return function(d) { return "Søk"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2115819674 = messageFormatterFn((function(  ) {
  return function(d) { return "Rediger innsjekkingsdatoen i tabellene nedenfor."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1978908437 = messageFormatterFn((function(  ) {
  return function(d) { return "Rediger utsjekkingsdatoen i tabellene nedenfor."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1891735590 = messageFormatterFn((function(  ) {
  return function(d) { return "er valgt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a479047 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er valgt. Lukk kalenderen eller fortsett for å endre den valgte datoen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a748167055 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " til " + d["1"] + " er valgt. Lukk kalenderen eller fortsett for å endre de valgte datoene."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1623504107 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er valgt. " + d["1"] + ". Lukk kalenderen eller fortsett for å endre den valgte datoen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b826515491 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " til " + d["1"] + " er valgt. " + d["2"] + ". Lukk kalenderen eller fortsett for å endre de valgte datoene."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1617943146 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg innsjekkingsdato"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b579311325 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg utsjekkingsdato"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a503479250 = messageFormatterFn((function(  ) {
  return function(d) { return "blank"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2104658352 = messageFormatterFn((function(  ) {
  return function(d) { return "Forrige måned"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a975699988 = messageFormatterFn((function(  ) {
  return function(d) { return "Neste måned"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2087329403 = messageFormatterFn((function(  ) {
  return function(d) { return "Hopp til knappen " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a748626579 = messageFormatterFn((function(  ) {
  return function(d) { return "Fra " + d["0"] + " til " + d["1"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1397289738 = messageFormatterFn((function(  ) {
  return function(d) { return "Datoene er tømt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2100759773 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "det finnes " + plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " resultater";}, one: function() { return number(d["0"]) + " resultat";}, two: function() { return number(d["0"]) + " resultater";}, few: function() { return number(d["0"]) + " resultater";}, many: function() { return number(d["0"]) + " resultater";}, other: function() { return number(d["0"]) + " resultater";} }); }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1144701388 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["1"]) + " resultater";}, one: function() { return number(d["1"]) + " resultat";}, two: function() { return number(d["1"]) + " resultater";}, few: function() { return number(d["1"]) + " resultater";}, many: function() { return number(d["1"]) + " resultater";}, other: function() { return number(d["1"]) + " resultater";} }) + " er tilgjengelig for " + d["0"] + ". Bruk piltastene eller sveip for å gå gjennom listen."; }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2134429088 = messageFormatterFn((function(  ) {
  return function(d) { return "Søkefeltet " + d["0"] + " er åpent, skriv inn søkeord."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a211145167 = messageFormatterFn((function(  ) {
  return function(d) { return "Du valgte " + d["0"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2067339028 = messageFormatterFn((function(  ) {
  return function(d) { return "Menyen er lukket."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b786073294 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Søket etter " + d["0"] + " er åpent. Viser for øyeblikket " + plural(d["1"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["1"]) + " forslag";}, one: function() { return number(d["1"]) + " forslag";}, two: function() { return number(d["1"]) + " forslag";}, few: function() { return number(d["1"]) + " forslag";}, many: function() { return number(d["1"]) + " forslag";}, other: function() { return number(d["1"]) + " forslag";} }) + " for " + d["2"] + ". Gå til listen nedenfor."; }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.b210727483 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Søkefeltet " + d["0"] + " er åpent, viser " + plural(d["1"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["1"]) + " forslag";}, one: function() { return number(d["1"]) + " forslag";}, two: function() { return number(d["1"]) + " forslag";}, few: function() { return number(d["1"]) + " forslag";}, many: function() { return number(d["1"]) + " forslag";}, other: function() { return number(d["1"]) + " forslag";} }) + ". Angi søkeord eller gå til listen nedenfor."; }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2120286111 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Søkefeltet " + d["0"] + " er åpent. " + d["1"] + " er valgt for øyeblikket. Viser " + plural(d["2"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["2"]) + " forslag";}, one: function() { return number(d["2"]) + " forslag";}, two: function() { return number(d["2"]) + " forslag";}, few: function() { return number(d["2"]) + " forslag";}, many: function() { return number(d["2"]) + " forslag";}, other: function() { return number(d["2"]) + " forslag";} }) + " for " + d["3"] + ". Gå til listen nedenfor."; }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.b894263705 = messageFormatterFn((function(  ) {
  return function(d) { return "Fullfør"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1365133310 = messageFormatterFn((function(  ) {
  return function(d) { return "Fjern alle"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b736254927 = messageFormatterFn((function(  ) {
  return function(d) { return "Valgte alternativer"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1346658690 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " fjernet."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b535824165 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle valg fjernet."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2126317130 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har skrevet inn data i tekstfeltet. Søk eller velg blant de foreslåtte kategoriene nedenfor."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1062097641 = messageFormatterFn((function(  ) {
  return function(d) { return "Søk etter «" + d["0"] + "»"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1898503146 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingen resultater for «" + d["0"] + "»"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1236096532 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyplass"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1316021739 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotell"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1847344811 = messageFormatterFn((function(  ) {
  return function(d) { return "Severdighet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b575066228 = messageFormatterFn((function(  ) {
  return function(d) { return "I nærheten"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1450345839 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv med «" + d["0"] + "»"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b856474252 = messageFormatterFn((function(  ) {
  return function(d) { return "Område/by"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1464614536 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyplass"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1049427472 = messageFormatterFn((function(  ) {
  return function(d) { return "Severdighet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b467098463 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotell"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1080829343 = messageFormatterFn((function(  ) {
  return function(d) { return "Adresse"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b845701163 = messageFormatterFn((function(  ) {
  return function(d) { return "Togstasjon"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1180878820 = messageFormatterFn((function(  ) {
  return function(d) { return "T-banestasjon"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b545489400 = messageFormatterFn((function(  ) {
  return function(d) { return "Steder i nærheten"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b229868799 = messageFormatterFn((function(  ) {
  return function(d) { return "Nylige søk"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1887076583 = messageFormatterFn((function(  ) {
  return function(d) { return "Andre søkte også etter"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a35527598 = messageFormatterFn((function(  ) {
  return function(d) { return "Utforsk populære reisemål"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1720126470 = messageFormatterFn((function(  ) {
  return function(d) { return "Populære reisemål"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b442455754 = messageFormatterFn((function(  ) {
  return function(d) { return "Topp reisemål for øyeblikket"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a590602040 = messageFormatterFn((function(  ) {
  return function(d) { return "Din posisjon"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b243011595 = messageFormatterFn((function(  ) {
  return function(d) { return "Posisjonstjenester deaktivert"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1780264901 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kan ikke fastslå posisjonen din. Aktiver posisjonstjenester på enheten din slik at vi kan fastslå posisjonen din, eller skriv inn et reisemål."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1613225911 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " rom";}, one: function() { return number(d["0"]) + " rom";}, two: function() { return number(d["0"]) + " rom";}, few: function() { return number(d["0"]) + " rom";}, many: function() { return number(d["0"]) + " rom";}, other: function() { return number(d["0"]) + " rom";} }) + ", " + plural(d["1"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["1"]) + " reisende";}, one: function() { return number(d["1"]) + " reisende";}, two: function() { return number(d["1"]) + " reisende";}, few: function() { return number(d["1"]) + " reisende";}, many: function() { return number(d["1"]) + " reisende";}, other: function() { return number(d["1"]) + " reisende";} }); }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1269719955 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " reisende";}, one: function() { return number(d["0"]) + " reisende";}, two: function() { return number(d["0"]) + " reisende";}, few: function() { return number(d["0"]) + " reisende";}, many: function() { return number(d["0"]) + " reisende";}, other: function() { return number(d["0"]) + " reisende";} }); }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1253719639 = messageFormatterFn((function(  ) {
  return function(d) { return "Verdien i feltet " + d["0"] + " er nå " + d["1"] + ". Verdien i feltet " + d["2"] + " er nå " + d["3"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a93802886 = messageFormatterFn((function(  ) {
  return function(d) { return "Bytt om på feltene " + d["0"] + " og " + d["1"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b773911571 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1088253710 = messageFormatterFn((function(  ) {
  return function(d) { return "Skjul passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a276011179 = messageFormatterFn((function(  ) {
  return function(d) { return "Viser nå " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1230623754 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " av " + d["1"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1908712940 = messageFormatterFn((function(  ) {
  return function(d) { return "Bilde " + d["0"] + " av " + d["1"] + ". " + d["2"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a965638505 = messageFormatterFn((function(  ) {
  return function(d) { return "Åpne neste bilde"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1453643291 = messageFormatterFn((function(  ) {
  return function(d) { return "Åpne forrige bilde"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1510195733 = messageFormatterFn((function(  ) {
  return function(d) { return "Åpne alle de " + d["0"] + " bildene"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1617918208 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vis " + plural(d["0"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["0"]) + " bilder";}, one: function() { return number(d["0"]) + " bilde";}, two: function() { return number(d["0"]) + " bilder";}, few: function() { return number(d["0"]) + " bilder";}, many: function() { return number(d["0"]) + " bilder";}, other: function() { return number(d["0"]) + " bilder";} }) + " av " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1086950979 = messageFormatterFn((function(  ) {
  return function(d) { return "Fullført:"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a736503595 = messageFormatterFn((function(  ) {
  return function(d) { return "Pågående:"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1754924263 = messageFormatterFn((function(  ) {
  return function(d) { return "Trinn " + d["0"] + " av " + d["1"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1060161187 = messageFormatterFn((function(  ) {
  return function(d) { return "Trinn " + d["0"] + " av " + d["1"] + ":"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a549427556 = messageFormatterFn((function(  ) {
  return function(d) { return "Bilde " + d["0"] + " av " + d["1"] + ". " + d["2"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a119532257 = messageFormatterFn((function(  ) {
  return function(d) { return "Neste bilde"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2056839331 = messageFormatterFn((function(  ) {
  return function(d) { return "Forrige bilde"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1414958031 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", utvid til visning med full skjerm"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b452495421 = messageFormatterFn((function(  ) {
  return function(d) { return "Objekt " + d["0"] + ", utvid til visning med full skjerm"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a416059399 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne siden"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1577343113 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis flere navigasjonsstier"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1539521997 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis færre navigasjonsstier"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1261501840 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " prosent, laster inn"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a918492651 = messageFormatterFn((function(  ) {
  return function(d) { return "Laster inn"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b705040667 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " " + d["1"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2114554180 = messageFormatterFn((function(  ) {
  return function(d) { return "Det oppsto en feil."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2024133472 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv å se denne videoen på www.youtube.com, eller aktiver Javascript hvis det er deaktivert i nettleseren din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1780415080 = messageFormatterFn((function(  ) {
  return function(d) { return "Spill av video"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b109077544 = messageFormatterFn((function(  ) {
  return function(d) { return "Sett videoen på pause"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b603039184 = messageFormatterFn((function(  ) {
  return function(d) { return "Videoen laster"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a863804006 = messageFormatterFn((function(  ) {
  return function(d) { return "360-graders bilde"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1539223424 = messageFormatterFn((function(  ) {
  return function(d) { return "Dette er et 360-graders bilde. Bruk Ctrl og piltastene (Windows) eller cmd-tasten og piltastene (Mac) til å flytte rundt i bildet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a311141235 = messageFormatterFn((function(  ) {
  return function(d) { return "Viser for øyeblikket: " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1350167662 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyttet til venstre. Posisjon: " + d["0"] + " grader"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2055277369 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyttet til høyre. Posisjon: " + d["0"] + " grader"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a52502822 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyttet opp"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1569464979 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyttet ned"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1430787042 = messageFormatterFn((function(  ) {
  return function(d) { return "Du er øverst"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a206395220 = messageFormatterFn((function(  ) {
  return function(d) { return "Du er nederst"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1211492568 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg alle radene"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a636892103 = messageFormatterFn((function(  ) {
  return function(d) { return "Opphev valg av alle radene"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b411907241 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorterer i synkende rekkefølge"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b905140497 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorterer i stigende rekkefølge"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b681641217 = messageFormatterFn((function(  ) {
  return function(d) { return "Kolonnen vises nå i synkende rekkefølge"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a248556489 = messageFormatterFn((function(  ) {
  return function(d) { return "Kolonnen vises nå i stigende rekkefølge"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1574840993 = messageFormatterFn((function(  ) {
  return function(d) { return "Utvid rad " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1971917442 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Viser " + d["0"] + " av " + plural(d["1"], 0, pluralFuncs["nb-NO"], { zero: function() { return number(d["1"]) + " elementer";}, one: function() { return number(d["1"]) + " element";}, two: function() { return number(d["1"]) + " elementer";}, few: function() { return number(d["1"]) + " elementer";}, many: function() { return number(d["1"]) + " elementer";}, other: function() { return number(d["1"]) + " elementer";} }); }
})(messageFormat.number, messageFormat.plural, {"nb-NO": Globalize("nb-NO").pluralGenerator()}), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1784483118 = messageFormatterFn((function(  ) {
  return function(d) { return "månedene som vises akkurat nå, er " + d["0"] + " " + d["1"] + " og " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1143763498 = messageFormatterFn((function(  ) {
  return function(d) { return "måneden som vises akkurat nå, er " + d["0"] + " " + d["1"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a438648427 = messageFormatterFn((function(  ) {
  return function(d) { return "månedene som vises akkurat nå, er fra " + d["0"] + " " + d["1"] + " til " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1866670330 = messageFormatterFn((function(  ) {
  return function(d) { return "Innsjekkingsdato tømt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1623986205 = messageFormatterFn((function(  ) {
  return function(d) { return "Utsjekkingsdato tømt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a908615714 = messageFormatterFn((function(  ) {
  return function(d) { return "Datoer tømt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a750636861 = messageFormatterFn((function(  ) {
  return function(d) { return "Tøm datoer"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b665720803 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1829183936 = messageFormatterFn((function(  ) {
  return function(d) { return "Neste"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1373985408 = messageFormatterFn((function(  ) {
  return function(d) { return "Forrige"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1486985894 = messageFormatterFn((function(  ) {
  return function(d) { return "Hopp til Velg-knappen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1393060519 = messageFormatterFn((function(  ) {
  return function(d) { return "Hopp til knappen " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1829678070 = messageFormatterFn((function(  ) {
  return function(d) { return "Neste måned"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a539454646 = messageFormatterFn((function(  ) {
  return function(d) { return "Forrige måned"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b853941377 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er valgt som innsjekkingsdato."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a212785340 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er valgt som utsjekkingsdato."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1621159579 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er ikke en gyldig innsjekkingsdato."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b862662902 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er ikke en gyldig utsjekkingsdato."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a750103783 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingen tilgjengelighet den " + d["0"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b845572904 = messageFormatterFn((function(  ) {
  return function(d) { return "I dag"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2093014262 = messageFormatterFn((function(  ) {
  return function(d) { return "Valgt innsjekkingsdato"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b897829757 = messageFormatterFn((function(  ) {
  return function(d) { return "Valgt utsjekkingsdato"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b406895726 = messageFormatterFn((function(  ) {
  return function(d) { return "Valgt dato"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1965079954 = messageFormatterFn((function(  ) {
  return function(d) { return "Startdato"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b588634969 = messageFormatterFn((function(  ) {
  return function(d) { return "Sluttdato"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1391352584 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt, lukk datovinduet uten å lagre endringene. Eller velg en dato nedenfor."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b640746169 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " av " + d["1"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1406598578 = messageFormatterFn((function(  ) {
  return function(d) { return "Trykk på escape-knappen for å fjerne."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a724073399 = messageFormatterFn((function(  ) {
  return function(d) { return "Trykk på escape-knappen for å lukke."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a3166598 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppgi et nummer lavere enn " + d["0"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1971393659 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppgi et nummer høyere enn " + d["0"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a896771448 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppgi et nummer mellom " + d["0"] + " og " + d["1"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1713275385 = messageFormatterFn((function(  ) {
  return function(d) { return "Påkrevd"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1624652835 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b335806954 = messageFormatterFn((function(  ) {
  return function(d) { return "Velkommen tilbake! Logg på med"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1502297348 = messageFormatterFn((function(  ) {
  return function(d) { return "Velkommen tilbake! Logg på og spar minst 10 % på tusenvis av overnattingssteder med medlemspriser."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1922134966 = messageFormatterFn((function(  ) {
  return function(d) { return "E-postadresse"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1849422167 = messageFormatterFn((function(  ) {
  return function(d) { return "Passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a273880724 = messageFormatterFn((function(  ) {
  return function(d) { return "Trenger du en konto?"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b926868062 = messageFormatterFn((function(  ) {
  return function(d) { return "Logger på"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a195813883 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på med Facebook"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1494768430 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på med Google"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2127266942 = messageFormatterFn((function(  ) {
  return function(d) { return "Hold meg pålogget"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1925671777 = messageFormatterFn((function(  ) {
  return function(d) { return "Hold meg pålogget (bruker cookies)."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1207085353 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1206725939 = messageFormatterFn((function(  ) {
  return function(d) { return "Registrer deg"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2119472855 = messageFormatterFn((function(  ) {
  return function(d) { return "Eller <a href=\"" + d["0"] + "\">logg på med Facebook</a>"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b898365197 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg har glemt passordet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1257990778 = messageFormatterFn((function(  ) {
  return function(d) { return "Angi e-postadresse"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a629458588 = messageFormatterFn((function(  ) {
  return function(d) { return "Angi en gyldig e-postadresse."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1111997831 = messageFormatterFn((function(  ) {
  return function(d) { return "Skriv inn passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a113835341 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv på nytt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b215642799 = messageFormatterFn((function(  ) {
  return function(d) { return "Det oppstod en feil"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a951097263 = messageFormatterFn((function(  ) {
  return function(d) { return "Rett opp feilen nedenfor for å fortsette"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1174486010 = messageFormatterFn((function(  ) {
  return function(d) { return "Rett opp de to feilene nedenfor for å fortsette"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b622816380 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på med e-postadressen din"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1502735951 = messageFormatterFn((function(  ) {
  return function(d) { return "Eller logg på med e-post"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1121333050 = messageFormatterFn((function(  ) {
  return function(d) { return "E-postadresse"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2115300359 = messageFormatterFn((function(  ) {
  return function(d) { return "eller"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2106847755 = messageFormatterFn((function(  ) {
  return function(d) { return "Har du glemt passordet?"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a109854312 = messageFormatterFn((function(  ) {
  return function(d) { return "Er du ikke medlem?"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1925479374 = messageFormatterFn((function(  ) {
  return function(d) { return "Opprett en konto"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b741571491 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved å logge på godtar jeg <a href=\"" + d["0"] + "\" target=\"_blank\">" + d["1"] + " vilkårene og betingelsene. <span class=\"is-visually-hidden\">åpnes i et nytt vindu</span></a>"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2070062297 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved å logge på " + d["0"] + "-kontoen min godtar jeg " + d["2"] + "s <a href=\"" + d["1"] + "\" target=\"_blank\">brukerbetingelser<span class=\"is-visually-hidden\">åpnes i et nytt vindu</span></a> og <a href=\"" + d["3"] + "\" target=\"_blank\">personvernerklæring<span class=\"is-visually-hidden\">åpnes i et nytt vindu</span></a> samt <a href=\"" + d["4"] + "\" target=\"_blank\">" + d["5"] + "' vilkår og betingelser<span class=\"is-visually-hidden\">åpnes i et nytt vindu</span></a>. "; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1211197603 = messageFormatterFn((function(  ) {
  return function(d) { return "Bli med i <a href=\"" + d["0"] + "\" target=\"_blank\">" + d["1"] + ". <span class=\"is-visually-hidden\">åpnes i et nytt vindu</span></a> Ved å bli med godtar du alle <a href=\"" + d["3"] + "\" target=\"_blank\">vilkår og betingelser. <span class=\"is-visually-hidden\">åpnes i et nytt vindu</span></a>"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1238398989 = messageFormatterFn((function(  ) {
  return function(d) { return "Vilkår gjelder, linker nederst på siden"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1931979775 = messageFormatterFn((function(  ) {
  return function(d) { return "Sjekk e-posten din!"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1444618150 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilbakestill passordet ditt med linken vi sendte til " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1218972467 = messageFormatterFn((function(  ) {
  return function(d) { return "Send linken på nytt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1125065191 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, det oppsto en feil"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1296741324 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv på nytt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2010650983 = messageFormatterFn((function(  ) {
  return function(d) { return "Gå tilbake"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1270145657 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har sendt en ny link."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b440992045 = messageFormatterFn((function(  ) {
  return function(d) { return "Opprett en konto på " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1914250252 = messageFormatterFn((function(  ) {
  return function(d) { return "Opprett en konto med"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1291130630 = messageFormatterFn((function(  ) {
  return function(d) { return "Opprett en konto med en e-postadresse"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a720548633 = messageFormatterFn((function(  ) {
  return function(d) { return "Eller opprett en konto med e-posten din"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a485665809 = messageFormatterFn((function(  ) {
  return function(d) { return "Fornavn og etternavn"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1344831253 = messageFormatterFn((function(  ) {
  return function(d) { return "Etternavn og fornavn"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b764922054 = messageFormatterFn((function(  ) {
  return function(d) { return "Må bestå av 8–30 tegn, uten mellomrom"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1028618588 = messageFormatterFn((function(  ) {
  return function(d) { return "Opprett konto"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1148241203 = messageFormatterFn((function(  ) {
  return function(d) { return "Har du allerede en konto?"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2025065561 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved å opprette en konto godtar jeg " + d["0"] + "s <a href=\"" + d["1"] + "\" target=\"_blank\"> brukerbetingelser, <span class=\"is-visually-hidden\">åpnes i et nytt vindu</span></a> <a href=\"" + d["2"] + "\" target=\"_blank\">personvernerklæring, <span class=\"is-visually-hidden\">åpnes i et nytt vindu</span></a> og <a href=\"" + d["3"] + "\" target=\"_blank\">" + d["4"] + "vilkår og betingelser. <span class=\"is-visually-hidden\">åpnes i et nytt vindu</span></a>."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1068469198 = messageFormatterFn((function(  ) {
  return function(d) { return "Send meg e-poster med reisetilbud, spesialkampanjer og annen informasjon."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1042433512 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har sendt deg en link på e-post så du kan fullføre opprettelsen av kontoen din. "; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1763537149 = messageFormatterFn((function(  ) {
  return function(d) { return "Klikk på linken i e-posten vi sendte til " + d["0"] + " for å fullføre opprettelsen av kontoen din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b863930062 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilbakestill passordet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1639007160 = messageFormatterFn((function(  ) {
  return function(d) { return "Skriv inn e-postadressen din, så sender vi deg en link slik at du kan tilbakestille passordet ditt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a821425342 = messageFormatterFn((function(  ) {
  return function(d) { return "Send link for tilbakestilling"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1124465166 = messageFormatterFn((function(  ) {
  return function(d) { return "eller betal som gjest"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2019930316 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg et nytt passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a266261195 = messageFormatterFn((function(  ) {
  return function(d) { return "Opprett et nytt passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1300172550 = messageFormatterFn((function(  ) {
  return function(d) { return "E-post: " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1615419004 = messageFormatterFn((function(  ) {
  return function(d) { return "Lagre passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2035064046 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, denne linken er ikke lenger gyldig"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b458910269 = messageFormatterFn((function(  ) {
  return function(d) { return "Du må be om en ny link for å tilbakestille passordet ditt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1388122115 = messageFormatterFn((function(  ) {
  return function(d) { return "Send ny link"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b71257132 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilbake til påloggingen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1175191469 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har sendt deg en ny link på e-post slik at du kan tilbakestille passordet."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1985543426 = messageFormatterFn((function(  ) {
  return function(d) { return "Hva er e-postadressen din?"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b692859961 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppgi en e-postadresse, slik at reiseleverandører og " + d["0"] + " kan kontakte deg.  Vi sender deg en sikkerhetskode for å bekrefte identiteten din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1658193562 = messageFormatterFn((function(  ) {
  return function(d) { return "Du opprettet kontoen din hos " + d["0"] + " med et telefonnummer. Skriv inn e-postadressen din, slik at vi kan fullføre påloggingen. Vi sender deg en sikkerhetskode for å bekrefte identiteten din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1033839565 = messageFormatterFn((function(  ) {
  return function(d) { return "Send sikkerhetskode"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b368497887 = messageFormatterFn((function(  ) {
  return function(d) { return "Skriv inn sikkerhetskode"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a420274553 = messageFormatterFn((function(  ) {
  return function(d) { return "Skriv inn sikkerhetskoden vi sendte til " + d["0"] + "."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1286040586 = messageFormatterFn((function(  ) {
  return function(d) { return "Sikkerhetskode"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1320201748 = messageFormatterFn((function(  ) {
  return function(d) { return "Send"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a538480482 = messageFormatterFn((function(  ) {
  return function(d) { return "Fikk du ikke e-posten?"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b113427806 = messageFormatterFn((function(  ) {
  return function(d) { return "Send ny kode"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b555334791 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har sendt deg en ny sikkerhetskode."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b986902716 = messageFormatterFn((function(  ) {
  return function(d) { return "Skriv inn en gyldig sikkerhetskode"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a972733475 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har forsøkt å få tilsendt ny sikkerhetskode for mange ganger. Prøv igjen om 24 timer."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2009752801 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har fylt inn feil sikkerhetskode for mange ganger. Prøv igjen om 24 timer."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a457418976 = messageFormatterFn((function(  ) {
  return function(d) { return "Fyll inn riktig sikkerhetskode."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b43335684 = messageFormatterFn((function(  ) {
  return function(d) { return "E-postadressen du oppga, er allerede blitt brukt til å opprette en konto på " + d["0"] + " med " + d["1"] + ". Prøv å logge deg på med " + d["1"] + "-kontoen som er tilknyttet den e-postadressen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b404785451 = messageFormatterFn((function(  ) {
  return function(d) { return "Som et sikkerhetstiltak må du tilbakestille passordet ditt for å kunne logge på."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1834701121 = messageFormatterFn((function(  ) {
  return function(d) { return "Hvis du har en konto hos " + d["0"] + ", sender vi deg en link slik at du kan tilbakestille passordet ditt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a364515276 = messageFormatterFn((function(  ) {
  return function(d) { return "Velkommen tilbake, " + d["0"] + "!"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1854695278 = messageFormatterFn((function(  ) {
  return function(d) { return "Det nye passordet ditt er lagret."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1969431268 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsett å søke"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1007210254 = messageFormatterFn((function(  ) {
  return function(d) { return "Velkommen, " + d["0"] + "!"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b79560176 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, det oppsto en feil"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a711023071 = messageFormatterFn((function(  ) {
  return function(d) { return "Korriger de " + d["0"] + " feilene nedenfor for å fortsette."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a602775382 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har angitt en ukjent e-postadresse eller feil passord."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1201401522 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kunne dessverre ikke koble til " + d["0"]; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1692330515 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, linken har utløpt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a933871923 = messageFormatterFn((function(  ) {
  return function(d) { return "Be om en ny link"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a26947769 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, økten din har utløpt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1831736257 = messageFormatterFn((function(  ) {
  return function(d) { return "Skriv inn fornavn og etternavn"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1795376903 = messageFormatterFn((function(  ) {
  return function(d) { return "Skriv inn etternavn og fornavn"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1167735787 = messageFormatterFn((function(  ) {
  return function(d) { return "Navnet må kun inneholde bokstaver."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b102251589 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne e-postadressen er allerede tilknyttet en konto hos " + d["0"] + ".  "; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a186927087 = messageFormatterFn((function(  ) {
  return function(d) { return "Passordet kan ikke inneholde mellomrom."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b292032560 = messageFormatterFn((function(  ) {
  return function(d) { return "Passordet kan ikke være det samme som e-postadressen din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a689532468 = messageFormatterFn((function(  ) {
  return function(d) { return "Dette passordet er enkelt å gjette."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1731838245 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne e-postadressen er allerede registrert."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b597894318 = messageFormatterFn((function(  ) {
  return function(d) { return "Passord er påkrevd."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1524428520 = messageFormatterFn((function(  ) {
  return function(d) { return "Dette passordet er feil."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a884119996 = messageFormatterFn((function(  ) {
  return function(d) { return "Passordet må bestå av minst " + d["0"] + " tegn."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a227203946 = messageFormatterFn((function(  ) {
  return function(d) { return "Passordet må bestå av mellom " + d["0"] + " og " + d["1"] + " tegn."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1551744934 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne e-postadressen har allerede blitt brukt til å opprette en konto på " + d["0"] + " med " + d["1"] + ". Bruk en annen e-postadresse eller logg på med " + d["1"] + "-kontoen tilknyttet denne e-posten"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1659048570 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, vi kunne ikke logge deg på med din Apple ID. Vi jobber med å støtte Apple ID-er som er telefonnumre. I mellomtiden kan du logge inn på en annen måte."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1301893412 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kunne ikke finne denne kontoen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a693671259 = messageFormatterFn((function(  ) {
  return function(d) { return "E-postadresse er påkrevd."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1402865836 = messageFormatterFn((function(  ) {
  return function(d) { return "Lukk påloggingsvinduet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1915652130 = messageFormatterFn((function(  ) {
  return function(d) { return "Lukk opprett en konto"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1106455289 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilbake til forrige side"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b414869536 = messageFormatterFn((function(  ) {
  return function(d) { return "Lukk bekreftelsesvinduet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b809057318 = messageFormatterFn((function(  ) {
  return function(d) { return "Lukk sikkerhetskodevinduet"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2049401124 = messageFormatterFn((function(  ) {
  return function(d) { return "Betal som gjest eller logg på"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1318797694 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg er en ny kunde"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2071917789 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan opprette konto etter at du har fullført bestillingen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1457622116 = messageFormatterFn((function(  ) {
  return function(d) { return "Betal som gjest"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1311105872 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg er allerede kunde"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1737060800 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på for å tjene og bruke poeng på bestillingen din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1559082391 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på og fullfør bestillingen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a722522114 = messageFormatterFn((function(  ) {
  return function(d) { return "eller fortsett med"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a70886776 = messageFormatterFn((function(  ) {
  return function(d) { return "Velkommen tilbake!"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1128586911 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på eller opprett en konto"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2080290772 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsett"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a420327574 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har sendt en link for å tilbakestille passordet til " + d["0"] + ". Det kan ta noen minutter før du mottar den. Sjekk søppelpostmappen hvis du ikke ser e-posten i innboksen din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1358640307 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilbakestill passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1172436363 = messageFormatterFn((function(  ) {
  return function(d) { return "Passordet ditt må bestå av minst 8 tegn."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1579412971 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsett med den tilkoblede kontoen din"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1499772459 = messageFormatterFn((function(  ) {
  return function(d) { return "eller opprett et passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1435467851 = messageFormatterFn((function(  ) {
  return function(d) { return "Sjekk e-posten din!"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1646958140 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har sendt en verifiseringslink til " + d["0"] + " slik at du kan opprette et passord. Det kan ta noen minutter før du mottar den. Sjekk søppelpostmappen hvis du ikke ser e-posten i innboksen din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1518816320 = messageFormatterFn((function(  ) {
  return function(d) { return "Opprett passord"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b113455018 = messageFormatterFn((function(  ) {
  return function(d) { return "Endre"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b179976056 = messageFormatterFn((function(  ) {
  return function(d) { return "Det ser ut til at du har bestilt med oss før. Av sikkerhetsmessige årsaker må vi verifisere e-postadressen din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1093509974 = messageFormatterFn((function(  ) {
  return function(d) { return "Bruk verifiseringslinken vi har sendt til " + d["0"] + " for å fullføre opprettelsen av kontoen din. Det kan ta noen minutter før du mottar den. Sjekk søppelpostmappen hvis du ikke ser e-posten i innboksen din."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1600768500 = messageFormatterFn((function(  ) {
  return function(d) { return "Mine reiseopplysninger"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1256859199 = messageFormatterFn((function(  ) {
  return function(d) { return "Min kontoinformasjon"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a2115942459 = messageFormatterFn((function(  ) {
  return function(d) { return "Oppdater personopplysninger og tilpass preferanser"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1386541861 = messageFormatterFn((function(  ) {
  return function(d) { return "TSA-informasjon"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a756451721 = messageFormatterFn((function(  ) {
  return function(d) { return "Legg til Known Traveler Number eller Redress-nummer"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a94171657 = messageFormatterFn((function(  ) {
  return function(d) { return "Personlige opplysninger"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1549286253 = messageFormatterFn((function(  ) {
  return function(d) { return "Del grunnleggende informasjon og fortell hvordan vi kan nå deg"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1031386884 = messageFormatterFn((function(  ) {
  return function(d) { return "Flypreferanser"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2041888088 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg innstillinger for å få en mer tilpasset brukeropplevelse"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b906477299 = messageFormatterFn((function(  ) {
  return function(d) { return "Bonusordninger"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1850763919 = messageFormatterFn((function(  ) {
  return function(d) { return "Lagre flybonusprogrammer og andre medlemskap"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1202249989 = messageFormatterFn((function(  ) {
  return function(d) { return "Pass"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b67985559 = messageFormatterFn((function(  ) {
  return function(d) { return "Lagre passet ditt for å bestille raskere"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1894716158 = messageFormatterFn((function(  ) {
  return function(d) { return "Administrering av enheter"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1583443490 = messageFormatterFn((function(  ) {
  return function(d) { return "Se dine påloggede enheter"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1005925066 = messageFormatterFn((function(  ) {
  return function(d) { return "Logg på for å se kontoen din"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1546700525 = messageFormatterFn((function(  ) {
  return function(d) { return "Opprett konto"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b557958604 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, det oppsto en feil."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a355365023 = messageFormatterFn((function(  ) {
  return function(d) { return "Det ser ut til at du er offline. Kontroller internettforbindelsen og prøv på nytt."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a349284377 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv igjen"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b2132637622 = messageFormatterFn((function(  ) {
  return function(d) { return "Laster inn ..."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b766133009 = messageFormatterFn((function(  ) {
  return function(d) { return "1 natt"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1461472841 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " netter"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a868753123 = messageFormatterFn((function(  ) {
  return function(d) { return "Ferdig, 1 natt valgt. Lagre endringene og lukk kalenderen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a1935898667 = messageFormatterFn((function(  ) {
  return function(d) { return "Ferdig, " + d["0"] + " netter valgt. Lagre endringene og lukk kalenderen."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1874526936 = messageFormatterFn((function(  ) {
  return function(d) { return "Velg dato"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1038838895 = messageFormatterFn((function(  ) {
  return function(d) { return "det finnes " + d["0"] + " resultater"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1842786999 = messageFormatterFn((function(  ) {
  return function(d) { return "det finnes 1 resultat"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a227699848 = messageFormatterFn((function(  ) {
  return function(d) { return "Dette innholdet ble betalt for av " + d["0"] + " og produsert av Expedia Group Media Studio. Redaksjonen hos Expedia Groups selskaper var ikke involvert i dette innholdet."; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b513525589 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotell"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b905704209 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygning"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1820106819 = messageFormatterFn((function(  ) {
  return function(d) { return "Pakke"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b470377013 = messageFormatterFn((function(  ) {
  return function(d) { return "Bil"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.a413546284 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktiviteter"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1480514635 = messageFormatterFn((function(  ) {
  return function(d) { return "Cruise"; }
})(), Globalize("nb-NO").pluralGenerator({}));
Globalize.b1834304763 = dateToPartsFormatterFn({"2":Globalize("nb-NO").numberFormatter({"raw":"00"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.a1172350982 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"}),"2":Globalize("nb-NO").numberFormatter({"raw":"00"})}, {"pattern":"y-MM-dd","timeSeparator":":"});
Globalize.a1346116165 = dateToPartsFormatterFn({"2":Globalize("nb-NO").numberFormatter({"raw":"00"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b1629965787 = dateToPartsFormatterFn({"2":Globalize("nb-NO").numberFormatter({"raw":"00"})}, {"pattern":"dd/MM/yy","timeSeparator":":"});
Globalize.a501528966 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"}),"2":Globalize("nb-NO").numberFormatter({"raw":"00"})}, {"pattern":"dd/MM/y","timeSeparator":":"});
Globalize.a1761503515 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"}),"2":Globalize("nb-NO").numberFormatter({"raw":"00"})}, {"pattern":"d/MM/yy","timeSeparator":":"});
Globalize.b719399976 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.b1842170760 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"}),"2":Globalize("nb-NO").numberFormatter({"raw":"00"})}, {"pattern":"d/M/yy","timeSeparator":":"});
Globalize.b890789677 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"d/M/y","timeSeparator":":"});
Globalize.b1841853934 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.a1347863379 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"y/M/d","timeSeparator":":"});
Globalize.a1400257189 = dateToPartsFormatterFn({"2":Globalize("nb-NO").numberFormatter({"raw":"00"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a148859525 = dateToPartsFormatterFn({"2":Globalize("nb-NO").numberFormatter({"raw":"00"})}, {"pattern":"dd.MM.yy","timeSeparator":":"});
Globalize.b1242204890 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"}),"2":Globalize("nb-NO").numberFormatter({"raw":"00"})}, {"pattern":"dd.MM.y","timeSeparator":":"});
Globalize.a1499596656 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"}),"2":Globalize("nb-NO").numberFormatter({"raw":"00"})}, {"pattern":"d.MM.y","timeSeparator":":"});
Globalize.a2029270490 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.a681357050 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"}),"2":Globalize("nb-NO").numberFormatter({"raw":"00"})}, {"pattern":"d.M.yy","timeSeparator":":"});
Globalize.b1779216879 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"d.M.y","timeSeparator":":"});
Globalize.b1096988091 = dateToPartsFormatterFn({"2":Globalize("nb-NO").numberFormatter({"raw":"00"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.a1909667654 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"}),"2":Globalize("nb-NO").numberFormatter({"raw":"00"})}, {"pattern":"y/MM/dd","timeSeparator":":"});
Globalize.a1454398213 = dateToPartsFormatterFn({"2":Globalize("nb-NO").numberFormatter({"raw":"00"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.a1927684837 = dateToPartsFormatterFn({"2":Globalize("nb-NO").numberFormatter({"raw":"00"})}, {"pattern":"dd-MM-yy","timeSeparator":":"});
Globalize.a1983892485 = dateToPartsFormatterFn({"2":Globalize("nb-NO").numberFormatter({"raw":"00"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b960971368 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a681837221 = dateToPartsFormatterFn({"2":Globalize("nb-NO").numberFormatter({"raw":"00"}),"4":Globalize("nb-NO").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b1243355590 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"S","mon":"M","tue":"T","wed":"O","thu":"T","fri":"F","sat":"L"}}}});
Globalize.b1287065083 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"søndag","mon":"mandag","tue":"tirsdag","wed":"onsdag","thu":"torsdag","fri":"fredag","sat":"lørdag"}}}});
Globalize.a1754656773 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"januar","2":"februar","3":"mars","4":"april","5":"mai","6":"juni","7":"juli","8":"august","9":"september","10":"oktober","11":"november","12":"desember"}}}});
Globalize.a1729878779 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.a12324408 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"}),"2":Globalize("nb-NO").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.b899932791 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"d. MMM","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"mai","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"des."}}}});
Globalize.b2147473888 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"d. MMMM","timeSeparator":":","months":{"M":{"4":{"1":"januar","2":"februar","3":"mars","4":"april","5":"mai","6":"juni","7":"juli","8":"august","9":"september","10":"oktober","11":"november","12":"desember"}}}});
Globalize.b90159979 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"d. MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"januar","2":"februar","3":"mars","4":"april","5":"mai","6":"juni","7":"juli","8":"august","9":"september","10":"oktober","11":"november","12":"desember"}}}});
Globalize.a1521051627 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"januar","2":"februar","3":"mars","4":"april","5":"mai","6":"juni","7":"juli","8":"august","9":"september","10":"oktober","11":"november","12":"desember"}}}});
Globalize.a1521736820 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"d. MMM y","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"mai","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"des."}}}});
Globalize.a588400969 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"EEEE d. MMM","timeSeparator":":","days":{"E":{"4":{"sun":"søndag","mon":"mandag","tue":"tirsdag","wed":"onsdag","thu":"torsdag","fri":"fredag","sat":"lørdag"}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"mai","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"des."}}}});
Globalize.a2140105240 = dateToPartsFormatterFn({"1":Globalize("nb-NO").numberFormatter({"raw":"0"})}, {"pattern":"E d. MMM","timeSeparator":":","days":{"E":{"1":{"sun":"søn.","mon":"man.","tue":"tir.","wed":"ons.","thu":"tor.","fri":"fre.","sat":"lør."}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"mai","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"des."}}}});
Globalize.b1455591012 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a1923633359 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"y-MM-dd"}));
Globalize.a1724829916 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a184951420 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"dd/MM/yy"}));
Globalize.a1252811343 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"dd/MM/y"}));
Globalize.b1782181404 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"d/MM/yy"}));
Globalize.a1095517231 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.a2061389455 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"d/M/yy"}));
Globalize.b1041963044 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"d/M/y"}));
Globalize.b26936727 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.a1196690012 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"y/M/d"}));
Globalize.a1778970940 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.a1963776732 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"dd.MM.yy"}));
Globalize.b490922513 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"dd.MM.y"}));
Globalize.a1108189575 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"d.MM.y"}));
Globalize.b450779599 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a289949969 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"d.M.yy"}));
Globalize.b1930390246 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"d.M.y"}));
Globalize.b718274340 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.b1634017265 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"y/MM/dd"}));
Globalize.a1833111964 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b552365252 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"dd-MM-yy"}));
Globalize.b1932361060 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a853945839 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.a1060550972 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b1394528957 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b2123225636 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.a918496220 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b1981804924 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"d"}));
Globalize.b379082673 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.b472074222 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b1768760137 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b1234935586 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.a1899765378 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.a1900450571 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b29329582 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b1776148305 = dateFormatterFn(Globalize("nb-NO").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a158470731 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.b1842608512 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"y-MM-dd","digitsRe":/\d/});
Globalize.b956075637 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.b604429589 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yy","digitsRe":/\d/});
Globalize.a1781536768 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/y","digitsRe":/\d/});
Globalize.b1253455979 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/MM/yy","digitsRe":/\d/});
Globalize.a306136222 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b2077974850 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yy","digitsRe":/\d/});
Globalize.a764171725 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/y","digitsRe":/\d/});
Globalize.b816317736 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.b1292142515 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"y/M/d","digitsRe":/\d/});
Globalize.b901934613 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.a1174395723 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yy","digitsRe":/\d/});
Globalize.a37802912 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.y","digitsRe":/\d/});
Globalize.a1263792566 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.MM.y","digitsRe":/\d/});
Globalize.b1240160608 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a445552960 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yy","digitsRe":/\d/});
Globalize.b124255477 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.y","digitsRe":/\d/});
Globalize.a895787403 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.b1105291840 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"y/MM/dd","digitsRe":/\d/});
Globalize.b847793589 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.b1341746261 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yy","digitsRe":/\d/});
Globalize.b318299317 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a64564830 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b1620354581 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a411605812 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^S/],["mon",/^M/],["tue",/^T/],["wed",/^O/],["thu",/^T/],["fri",/^F/],["sat",/^L/]]});
Globalize.a1260172747 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["tue",/^tirsdag/],["thu",/^torsdag/],["sun",/^søndag/],["mon",/^mandag/],["wed",/^onsdag/],["fri",/^fredag/],["sat",/^lørdag/]]});
Globalize.a6927307 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^november/],["12",/^desember/],["2",/^februar/],["10",/^oktober/],["1",/^januar/],["8",/^august/],["4",/^april/],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^mai/]]});
Globalize.a755375349 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.b223479682 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.a826918275 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^des\./],["5",/^mai/]]});
Globalize.b154698394 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^november/],["12",/^desember/],["2",/^februar/],["10",/^oktober/],["1",/^januar/],["8",/^august/],["4",/^april/],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^mai/]]});
Globalize.a1556338191 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^november/],["12",/^desember/],["2",/^februar/],["10",/^oktober/],["1",/^januar/],["8",/^august/],["4",/^april/],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^mai/]]});
Globalize.b781140175 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^november/],["12",/^desember/],["2",/^februar/],["10",/^oktober/],["1",/^januar/],["8",/^august/],["4",/^april/],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^mai/]]});
Globalize.b780454982 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^des\./],["5",/^mai/]]});
Globalize.b1969789885 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE d. MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["tue",/^tirsdag/],["thu",/^torsdag/],["sun",/^søndag/],["mon",/^mandag/],["wed",/^onsdag/],["fri",/^fredag/],["sat",/^lørdag/]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^des\./],["5",/^mai/]]});
Globalize.b162086562 = dateParserFn(Globalize("nb-NO").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E d. MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^søn\./],["mon",/^man\./],["tue",/^tir\./],["wed",/^ons\./],["thu",/^tor\./],["fri",/^fre\./],["sat",/^lør\./]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^des\./],["5",/^mai/]]});
module.exports = Globalize;
